import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Container = styled.div({
})

export const THeader = styled.div({
  display:'flex', 
  alignItems:'center',
  'span':{
    fontWeight:'bold'
  }
})

export const TList = styled.div({
  display:'flex',
})

export const TListLine = styled.div((props)=>({
  marginLeft:'0.9rem', 
  height:`${props.isLast?'0':'auto'}`, 
  minHeight:`${props.isLast?'0':'1rem'}`, 
  width:3, 
  background:v.ezMainColor
}))

export const TItemCont = styled.div({
  display:'flex', 
  marginBottom:'1rem',
  
  '.lineV1':{
    marginLeft:'2rem', 
    height:'2rem', 
    width:2, 
    background:v.ezMainColor
  },
  '.lineV2':{
    position:'relative', 
    top:'-1rem', 
    height:'1rem', 
    width:2, 
    background:v.ezMainColor
  },
  '.lineH':{
    alignSelf:'flex-end',
    height:2, 
    width:'2rem', 
    background:v.ezMainColor
  },

  '.label':{
    position:'relative', top:'0.9rem'
  },
  '.labelNotFound':{
    fontStyle:'italic', 
    position:'relative', 
    top:'0.6rem',
    marginLeft:'0.2rem', 
    marginRight:'1rem', 
    alignSelf:'flex-end'
  },
})

export const TItemData = styled.div({
  display:'flex',

  '.docNum':{
    marginLeft:'0.2rem', 
    marginRight:'1rem', 
    alignSelf:'flex-end'
  }
})